import Axios from "../../configs/axios.config";

export const createTeam = (data) => Axios.post(`/team`, data).then(response=>response.data.data);
export const updateTeam = (data, id) => Axios.put(`/team/${id}`, data).then(response=>response.data.data);
export const getTeamList = (data) => Axios.get('/team', { params: data }).then(response=>response.data);
export const getTeamDetail = (id) => Axios.get(`/team/${id}`).then(response=>response.data);
export const deleteTeam = (id) => Axios.delete(`/team/${id}`);
